import { Component, OnInit } from '@angular/core';
import { SystemService } from './services/system.service';
import { LanguageService } from './services/language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(private languageService: LanguageService, private systemService: SystemService) {
    this.languageService.init();
  }

  get direction(): 'rtl' | 'ltr' {
    return this.languageService.direction;
  }

  ngOnInit(): void {
    this.systemService.applyTheme();
  }
}
